import React, { useState, createContext, useContext } from 'react';
import { translations } from './translations';
type Language = 'en' | 'es';
interface LanguageContextType {
  language: Language;
  setLanguage: (lang: Language) => void;
  hasSelected: boolean;
  selectLanguage: (lang: Language) => void;
  t: typeof translations.en;
}
const LanguageContext = createContext<LanguageContextType | undefined>(undefined);
export function LanguageProvider({
  children
}: {
  children: ReactNode;
}) {
  const [language, setLanguage] = useState<Language>('en');
  const [hasSelected, setHasSelected] = useState(false);
  const selectLanguage = (lang: Language) => {
    setLanguage(lang);
    setHasSelected(true);
  };
  const value = {
    language,
    setLanguage,
    hasSelected,
    selectLanguage,
    t: translations[language]
  };
  return <LanguageContext.Provider value={value} data-id="element-159">
      {children}
    </LanguageContext.Provider>;
}
export function useLanguage() {
  const context = useContext(LanguageContext);
  if (context === undefined) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
}